import { AppSettingsService } from 'src/services/appsettings.service';
import { MessageService } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { AppNav } from 'src/routes/app-nav';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import Helpers from 'src/shared/helpers';
// @ts-ignore
import Headroom from 'headroom.js';

@Component({
  selector: 'app-root',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  showMasthead: boolean = true;
  showFooter: boolean = true;
  appVersion: string | undefined;
  isIframe: boolean = false;
  loginDisplay: boolean = false;
  showPageLoadingIndicator: boolean = false;
  private readonly _destroying$ = new Subject<void>();

  private hideMastheadUrls: string[] = [`/${AppNav.Login.route}`];

  private hideFooterUrls: string[] = [`/${AppNav.Login.route}`];

  constructor(
    private appSettingsService: AppSettingsService,
    private router: Router,
    private primengConfig: PrimeNG,
    private messageService: MessageService
  ) {
    this.showOrHideMastheadAndFooter(this.router.url);

    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError
        )
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (event.url.includes('#')) {
            return;
          }

          if (event.url === window.location.pathname) {
            return;
          }

          this.showPageLoadingIndicator = true;
          return;
        }

        setTimeout(() => {
          this.showPageLoadingIndicator = false;
        }, 400);
      });
  }

  async ngOnInit() {
    this.isIframe = Helpers.isIframe();

    this.primengConfig.ripple.set(true);

    // keep it before redirect to apply hideMastheadUrls & hideFooterUrls
    this.subscribeToRouterChanges();

    await this.appSettingsService.load();
    this.appVersion = `v${this.appSettingsService.settings.version}`;
  }

  private subscribeToRouterChanges(): void {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        let url = val.urlAfterRedirects ? val.urlAfterRedirects : val.url;

        this.showOrHideMastheadAndFooter(url);
        this.initStickyMasthead();
        this.messageService.clear();
      }
    });
  }

  private initStickyMasthead(): void {
    const mastHead = document.querySelector('app-masthead:not(.headroom)');

    if (!mastHead) {
      window.requestAnimationFrame(() => this.initStickyMasthead());
      return;
    }

    const headroom = new Headroom(mastHead, {
      // @ts-ignore
      offset: {
        up: 0,
        down: 0,
      },
    });

    headroom.init();
  }

  private showOrHideMastheadAndFooter(url: string): void {
    this.showMasthead = this.hideMastheadUrls.indexOf(url) === -1;
    this.showFooter = this.hideFooterUrls.indexOf(url) === -1;
  }

  // setLoginDisplay() {
  //   console.log(this.authService.instance.getAllAccounts());
  //   this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  // }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
